import { render, staticRenderFns } from "./RolesDetail.vue?vue&type=template&id=57427f60"
import script from "./RolesDetail.vue?vue&type=script&lang=js"
export * from "./RolesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports